<template>
  <div class="page-wrapper clearfix">
    <!-- v-show="total>pageSize" -->
    <div class="page-tab fl clearfix" >
      <button class="fl h50 cursor" :class="{ 'canNot': currentPage == 1 }" @click="firstPage" :disabled="preDisabled" style="margin-right:8px">
        首页
      </button>
      <!-- :class="{ 'canNot': currentPage == 1 }" -->
      <button class="fl h50 cursor" @click="upperPage" :class="{ 'canNot': currentPage == 1 }" :disabled="preDisabled" style="margin-left:8px">
        上一页
      </button>
      <ul class="fl">
        <li v-for="(item, index) in itemArr" :key="index" class="cursor" @click="changePage(item)" :class="{ activePage: currentPage === item }">
          {{ item }}
        </li>
      </ul>
      <button class="fl h50 cursor" @click="nextPage" :class="{ 'canNot': currentPage == totalPages }" :disabled="nextDisabled" style="margin-left:8px">
        下一页
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "VuePagination",
  props: {
    pageSize: {
      // 每页显示数量
      default: 0,
      type: Number
    },
    total: {
      // 总数
      default: 0,
      type: Number
    },
    nowCurrent: {
      type: Number,
      default: 1
    },
    tab: {
      type: Boolean,
      default: false
    },
    pageSizeSettings: {
      // 配置下拉 选pageSize
      type: Array,
      default() {
        return [5, 10, 15, 20];
      }
    }
  },
  data() {
    return {
      itemsShow: false, // 控制每页条数下拉框
      itemArr: [], // 显示页数,
      nextDisabled: null,
      preDisabled: "disabled",
      totalPages: 1, // 默认页数
      currentPage: 1,
      size: this.pageSize // 获取每页数量
    };
  },
  computed: {
    pageNum() {
      // 由于父组件传递过来的属性 子组件的钩子里面不能直接使用 用计算属性代替接收
      let a = this.size;
      return a;
    },
    pageItems() {
      let b = this.total;
      return b;
    }
  },
  created() {
    this.pages();
  },
  methods: {
    chooseNum(item) {
      // 改变pageSize
      this.itemsShow = false;
      this.size = item;
    },
    handleChooseNumClick() {
      this.itemsShow = !this.itemsShow; 
    },
    blur() {
      var that = this;
      setTimeout(function () {
        that.itemsShow = false;
      }, 200);
    },
    // 切换页数
    changePage(page) {
      this.currentPage = page;
      this.$emit("getPage", this.currentPage);
      this.pages();
    },
    // 上一页
    upperPage() { 
      if (this.currentPage > 1) {
        this.currentPage--;
      }
      this.$emit("getPage", this.currentPage);
    },
    // 下一页
    nextPage() {
      if (this.currentPage <= this.totalPages - 1) {
        this.currentPage++;
      }
      this.$emit("getPage", this.currentPage);
    },
    // 首页
    firstPage() {
      this.currentPage = 1;
      this.$emit("getPage", this.currentPage);
    },
    // 尾页
    lastPage() {
      this.currentPage = this.totalPages;
      this.$emit("getPage", this.currentPage);
    },
    prePage() {
      // 上一页
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    //分页器构建
    pages() {
      // 页数改变的逻辑
      this.itemArr = []; // 每次改变得清空数组
      this.totalPages = Math.ceil(this.pageItems / this.pageNum);
      this.preDisabled = this.currentPage === 1 ? "disabled" : null;
      this.nextDisabled =
        this.currentPage === this.totalPages ? "disabled" : null;
      let start = this.currentPage - 2 > 1 ? this.currentPage - 2 : 1;
      let end =
        this.currentPage > 3
          ? this.totalPages - this.currentPage >= 2
            ? this.currentPage + 2
            : this.totalPages
          : 5;
      start = this.totalPages - this.currentPage >= 2 ? start : end - 4;
      if (this.totalPages <= 5) {
        start = 1;
        end = this.totalPages;
      }
      for (let i = start; i <= end; i++) {
        this.itemArr.push(i);
      }
    }
  },
  watch: {
    pageNum() {
      // 每页数量变化后传递出 pageSize 重新请求数据
      this.currentPage = 1; // 改变每页数据 页码回到初始值
      this.pages();
      this.$emit("size-change", {
        pageSize: this.pageNum
      });
    },
    currentPage() {
      // 当前页数变化后 传递出当前页码 重新请求数据
      this.pages();
      this.$emit("current-change", {
        pageSize: this.pageNum,
        currentPage: this.currentPage
      });
    },
    total() {
      // 数据是异步加载的 组件刚开始total是默认的是渲染不了的
      this.pages();
    },
    tab() {
      // 点击切换条件筛选 重置currentPage
      this.currentPage = 1;
    }
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}

ul,
li {
  list-style: none;
}

.clearfix:after {
  content: ".";
  height: 0;
  display: block;
  visibility: hidden;
  clear: both;
  overflow: hidden;
}

.cursor {
  cursor: pointer;
}

.clearfix {
  zoom: 1;
}

.page-wrapper .fl {
  float: left;
}
.page-wrapper {
  font-size: 14px;
  color: #5e6470;
}
.h50 {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  border: 1px solid #eaedf1;
}

.page-wrapper .page-tab li {
  float: left;
  width: 2.222vh;
  height: 2.222vh;
  text-align: center;
  line-height: 2.222vh;
  color: #005a51;
  border: 1px solid #005a51;
  margin: 0px 4px 0px 4px;
  box-sizing: border-box;
}

.page-wrapper .page-info {
  margin-right: 6px;
}

.page-wrapper .page-info .h50 {
  border: none;
  padding: 0;
}

.items-choose .h50 {
  padding: 0;
  border: none 0;
  border-top: 1px solid #eaedf1;
  border-bottom: 1px solid #eaedf1;
  box-sizing: border-box;
  padding: 0 6px;
}

.items-choose .items-show {
  height: 30px;
  width: 74px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #eaedf1;
  position: relative;
}
.items-choose .items-show input {
  height: 100%;
  width: 100%;
  text-align: center;
}
.items-choose .items-show:after {
  content: "";
  position: absolute;
  height: 0;
  border: 4px solid transparent;
  border-top: 6px solid #c4ccc5;
  top: 50%;
  right: 10px;
  transform: translate3d(-50, -50, 0);
  cursor: pointer;
}

.items-choose .items-num {
  width: 100%;
  position: absolute;
  bottom: 42px;
  border: 1px solid #eaedf1;
  z-index: 100;
  background: #f5f7fa;
  z-index: 999;
}

.items-choose .items-num li {
  padding: 10px 0 10px 6px;
  font-size: 1.296vh;
}

.items-choose .items-num li:hover {
  /*background: #1AB394;*/
  background: #4a8df0;
  color: #fff;
}

.page-wrapper .activePage {
  /*
  width: 24px !important;
  height: 24px !important; */
  background: #005a51;
  color: white !important;
  margin: 0px 4px 0px 4px;
  cursor: pointer;
}

.canNot {
  cursor: not-allowed;
}

.page-wrapper button {
  background-color: #005a51;
  font-size: 1.111vh;
  color: #fff;
  height: 2.222vh;
  line-height: 2.222vh;
}
.chooseNum {
  cursor: pointer;
  font-size: 1.296vh;
  color: #5e6470;
}
.indexBtnF {
  margin-right: 10px;
  background-color: #005a51;
  color: #fff;
}
.nextBtnC {
  margin-left: 10px;
  background-color: #005a51;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NewPagunation.vue